module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("His Love Endures Forever: A Land of Canaan Novel")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e9819"
    }
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e1039"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter2",
      "id": "d6e2"
    }
  }, [_vm._v("Pennsylvania Dutch Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e9899"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter3",
      "id": "d6e3"
    }
  }, [_vm._v("One")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e9929"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter4",
      "id": "d6e4"
    }
  }, [_vm._v("Two")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e9979"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter5",
      "id": "d6e5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10009"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter6",
      "id": "d6e6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10049"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "id": "d6e7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10079"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "id": "d6e8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10129"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter9",
      "id": "d6e9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10159"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "id": "d6e10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10199"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "id": "d6e11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10249"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "id": "d6e12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "id": "d6e121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleven")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "id": "d6e122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twelve")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "id": "d6e123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "id": "d6e124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fourteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "id": "d6e125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "id": "d6e126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sixteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "id": "d6e127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seventeen")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "id": "d6e128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eighteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "id": "d6e129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nineteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "id": "d6e1210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "id": "d6e1211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-One")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "id": "d6e1212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Two")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "id": "d6e1213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Three")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "id": "d6e1214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Four")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "id": "d6e1215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Group Guide")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "id": "d6e1216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amish Recipes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10279"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "id": "d6e13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10279a"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter1#bb_2",
      "id": "aa_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Excerpt from "), _c('i', [_vm._v("Need You Now")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e10319"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter1a",
      "id": "d6e15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1a3e244","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1d.vue
// module id = 75
// module chunks = 0